// extracted by mini-css-extract-plugin
export var bar = "index-module--bar--GZjqr";
export var fadein = "index-module--fadein--C8mKS";